import { render, staticRenderFns } from "./FormSubmissionDetailsPage.vue?vue&type=template&id=fe624280&scoped=true"
import script from "./FormSubmissionDetailsPage.vue?vue&type=script&lang=js"
export * from "./FormSubmissionDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./FormSubmissionDetailsPage.vue?vue&type=style&index=0&id=fe624280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe624280",
  null
  
)

export default component.exports